module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Toko")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/menu_toko"
    }
  }, [_vm._v("Menu")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_c('h4', [_c('b', [_vm._v("MENU")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "20px",
      "padding-top": "10px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Toko"
    },
    on: {
      "change": _vm.handleSelect1
    },
    model: {
      value: (_vm.toko1),
      callback: function($$v) {
        _vm.toko1 = $$v
      },
      expression: "toko1"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1), _vm._v("\n                       \n                      "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "icon": "el-icon-search",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.getData()
      }
    }
  }), _vm._v(" "), (_vm.level.indexOf('ADMIN') !== -1) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "icon": "el-icon-plus",
      "type": "success",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN') !== -1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-sort",
      "disabled": _vm.cari_nama !== '',
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormMenu = true
      }
    }
  }, [_c('b', [_vm._v("UPDATE URUTAN MENU")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.tableData,
      "max-height": "520",
      "responsive": ""
    },
    on: {
      "selection-change": _vm.handleSelectionMenuChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "MENU MASTER",
      "prop": "nama",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Nama"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariNama()
            }
          },
          model: {
            value: (_vm.cari_nama),
            callback: function($$v) {
              _vm.cari_nama = $$v
            },
            expression: "cari_nama"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "MENU TOKO",
      "prop": "menu_toko",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Nama"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariMenuToko()
            }
          },
          model: {
            value: (_vm.cari_menutoko),
            callback: function($$v) {
              _vm.cari_menutoko = $$v
            },
            expression: "cari_menutoko"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.menu_toko))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "PROMO",
      "prop": "promo",
      "header-align": "center",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Promo"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariPromo()
            }
          },
          model: {
            value: (_vm.cari_promo),
            callback: function($$v) {
              _vm.cari_promo = $$v
            },
            expression: "cari_promo"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.promo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "HARGA",
      "prop": "harga",
      "header-align": "left",
      "align": "left",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(_vm.toMoney(scope.row.harga)) + "\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "KATEGORI",
      "prop": "kategori",
      "header-align": "left",
      "align": "left",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Kategori"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariKategori()
            }
          },
          model: {
            value: (_vm.cari_kategori),
            callback: function($$v) {
              _vm.cari_kategori = $$v
            },
            expression: "cari_kategori"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.kategori))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "BARCODE",
      "prop": "barcode",
      "header-align": "left",
      "align": "left",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.barcode) + "\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "PILIHAN",
      "align": "center",
      "header-align": "center",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ok",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-check"
          },
          on: {
            "click": function($event) {
              _vm.confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Naikkan",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "default",
            "size": "small",
            "icon": "el-icon-caret-top"
          },
          on: {
            "click": function($event) {
              return _vm.confirmNaik(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Turunkan",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "default",
            "size": "small",
            "icon": "el-icon-caret-bottom"
          },
          on: {
            "click": function($event) {
              return _vm.confirmTurun(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Edit",
            "placement": "top-start"
          }
        }, [(_vm.level.indexOf('ADMIN') !== -1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.confirmEdit(scope.$index, scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (scope.row.edit1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Cancel",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "el-icon-error",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.cancelEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Hapus",
            "placement": "top-start"
          }
        }, [(_vm.level.indexOf('ADMIN') !== -1) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDel(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Duplikasi",
            "placement": "top-start"
          }
        }, [(_vm.level.indexOf('ADMIN') !== -1) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-share"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDuplikasi(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.level.indexOf('ADMIN') !== -1) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "size": "medium",
      "disabled": _vm.kode_menu_terpilih == ''
    },
    on: {
      "click": function($event) {
        return _vm.confirmHapus(_vm.nama_toko)
      }
    }
  }, [_c('b', [_vm._v("HAPUS")])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN') !== -1) ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-share",
      "size": "medium",
      "disabled": _vm.kode_menu_terpilih == ''
    },
    on: {
      "click": function($event) {
        _vm.dialogFormDuplikasiMulti = true
      }
    }
  }, [_c('b', [_vm._v("DUPLIKASI")])]) : _vm._e(), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Menu",
      "visible": _vm.dialogFormVisible,
      "width": "700px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-position": "top",
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "kode_toko"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Toko"
    },
    on: {
      "change": _vm.handleSelect
    },
    model: {
      value: (_vm.row1.kode_toko),
      callback: function($$v) {
        _vm.$set(_vm.row1, "kode_toko", $$v)
      },
      expression: "row1.kode_toko"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Menu Master",
      "prop": "nama"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "550px"
    },
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "icon": "el-icon-search",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.showMasterMenu()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Menu Toko",
      "prop": "menu_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.menu_toko),
      callback: function($$v) {
        _vm.$set(_vm.row1, "menu_toko", $$v)
      },
      expression: "row1.menu_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Harga Jual",
      "prop": "harga"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.harga),
      callback: function($$v) {
        _vm.$set(_vm.row1, "harga", $$v)
      },
      expression: "row1.harga"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategori",
      "prop": "kategori"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.kategori),
      callback: function($$v) {
        _vm.$set(_vm.row1, "kategori", $$v)
      },
      expression: "row1.kategori"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Barcode",
      "prop": "barcode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.barcode),
      callback: function($$v) {
        _vm.$set(_vm.row1, "barcode", $$v)
      },
      expression: "row1.barcode"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tanggal Aktif",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Tanggal"
    },
    on: {
      "change": _vm.handleChangeTglAktif
    },
    model: {
      value: (_vm.tgl_aktif),
      callback: function($$v) {
        _vm.tgl_aktif = $$v
      },
      expression: "tgl_aktif"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tanggal Berakhir (biarkan jika tidak dipakai)",
      "prop": "tanggal2"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Tanggal"
    },
    model: {
      value: (_vm.tgl_berakhir),
      callback: function($$v) {
        _vm.tgl_berakhir = $$v
      },
      expression: "tgl_berakhir"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "promo"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Simpan sebagai menu PROMO"
    },
    model: {
      value: (_vm.promo),
      callback: function($$v) {
        _vm.promo = $$v
      },
      expression: "promo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "type": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Pilihan Master Menu",
      "visible": _vm.dialogMasterMenu,
      "width": "800px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogMasterMenu = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "grid-content",
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Filter Kata Kunci"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.handleSelect_.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.carinama),
      callback: function($$v) {
        _vm.carinama = $$v
      },
      expression: "carinama"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    ref: "singleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.pegawai,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "current-change": _vm.handleCurrentChangePegawai
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "width": "50px",
      "header-align": "center",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.$index + 1) + ".\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Menu Master",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Kategori",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.kategori) + "\n                  ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Menu",
      "visible": _vm.dialogFormEdit,
      "width": "700px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEdit",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Menu Master",
      "prop": "nama1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Menu Toko",
      "prop": "menu_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.menu_toko),
      callback: function($$v) {
        _vm.$set(_vm.row1, "menu_toko", $$v)
      },
      expression: "row1.menu_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Harga Jual",
      "prop": "harga"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.harga),
      callback: function($$v) {
        _vm.$set(_vm.row1, "harga", $$v)
      },
      expression: "row1.harga"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategori",
      "prop": "kategori"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.kategori),
      callback: function($$v) {
        _vm.$set(_vm.row1, "kategori", $$v)
      },
      expression: "row1.kategori"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Barcode",
      "prop": "barcode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.barcode),
      callback: function($$v) {
        _vm.$set(_vm.row1, "barcode", $$v)
      },
      expression: "row1.barcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "promo"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Simpan sebagai menu PROMO"
    },
    model: {
      value: (_vm.promo),
      callback: function($$v) {
        _vm.promo = $$v
      },
      expression: "promo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tanggal Perubahan",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Tanggal"
    },
    model: {
      value: (_vm.tgl_aktif),
      callback: function($$v) {
        _vm.tgl_aktif = $$v
      },
      expression: "tgl_aktif"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEdit = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel,
      "width": "500px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus data "), _c('b', [_vm._v(_vm._s(_vm.nama))]), _vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalHapus),
      expression: "loadingModalHapus"
    }],
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormHapus,
      "width": "800px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormHapus = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.region,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Pilih Semua"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormHapus = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.kode_toko_terpilih == ''
    },
    on: {
      "click": function($event) {
        return _vm.confirmHapus1()
      }
    }
  }, [_vm._v("Hapus Sekarang")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDuplikasi),
      expression: "loadingModalDuplikasi"
    }],
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormDuplikasi,
      "width": "800px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormDuplikasi = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.region,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Pilih Semua"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormDuplikasi = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.kode_toko_terpilih == ''
    },
    on: {
      "click": function($event) {
        return _vm.confirmDuplikasi1()
      }
    }
  }, [_vm._v("Duplikasi Sekarang")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalMenu),
      expression: "loadingModalMenu"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormMenu,
      "width": "500px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormMenu = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan meng-update nomor urut menu?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormMenu = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmMenu1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDeleteMulti),
      expression: "loadingModalDeleteMulti"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormDeleteMulti,
      "width": "500px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormDeleteMulti = $event
      }
    }
  }, [_c('h4', [_vm._v("Anda yakin akan menghapus menu terpilih?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormDeleteMultiToko = true
      }
    }
  }, [_vm._v("Hapus juga untuk toko lainnya")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDeleteMulti1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Informasi",
      "visible": _vm.dialogFormInfo,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDuplikasiMulti),
      expression: "loadingModalDuplikasiMulti"
    }],
    attrs: {
      "title": "Silahkan pilih toko",
      "visible": _vm.dialogFormDuplikasiMulti,
      "width": "800px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormDuplikasiMulti = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.region,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Pilih Semua"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormDuplikasiMulti = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.kode_toko_terpilih == ''
    },
    on: {
      "click": function($event) {
        return _vm.confirmDuplikasiMulti1()
      }
    }
  }, [_vm._v("Duplikasi Sekarang")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDeleteMultiToko),
      expression: "loadingModalDeleteMultiToko"
    }],
    attrs: {
      "title": "Silahkan pilih toko",
      "visible": _vm.dialogFormDeleteMultiToko,
      "width": "800px",
      "top": "1%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormDeleteMultiToko = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.region,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Pilih Semua"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormDeleteMultiToko = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.kode_toko_terpilih == ''
    },
    on: {
      "click": function($event) {
        return _vm.confirmDeleteMultiToko1()
      }
    }
  }, [_vm._v("Hapus Sekarang")])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88293fac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/MenuToko1.vue
// module id = 1424
// module chunks = 2